import { useNavigation } from '@react-navigation/native';
import AccountContext from 'context/AccountContext';
import { useContext } from 'react';
import { useAppConfigStore } from 'stores/appConfigStore';
import { useCityParkingStore } from 'stores/cityParkingStore';
import { usePermitStore } from 'stores/permitStore';
import { Maybe, Pmc } from 'types/generatedSchemaTypes';
import { CityParkingNavProps } from 'types/navigation';
import { isPermitForParkingZone } from 'utils/permitUtils';
import useCityPmcsByMembergroup from './useCityPmcsByMembergroup';

const useSelectCityPmc = () => {
  const {
    customer: { permits },
  } = useContext(AccountContext);
  const { navigate } = useNavigation<CityParkingNavProps>();
  const { cityPmcs } = useCityPmcsByMembergroup();

  const setSelectedCityPmc = useCityParkingStore(
    (state) => state.setSelectedPmc
  );

  const hasPermit = (parkZoneUid?: Maybe<string>) =>
    permits?.find(
      (unifiedPermit) =>
        unifiedPermit &&
        parkZoneUid &&
        isPermitForParkingZone(parkZoneUid, unifiedPermit)
    );

  const onItemSelect = (parkZoneUid: Maybe<string> | undefined) => {
    const pmcItem = cityPmcs?.find(
      (pmc) => pmc.physicalZoneUid === parkZoneUid
    ) as Pmc;
    const existingPermit = hasPermit(parkZoneUid);
    setSelectedCityPmc(pmcItem);
    if (existingPermit) {
      usePermitStore.getState().setSelectedPmc(pmcItem ?? undefined);
      usePermitStore
        .getState()
        .setSelectedPermit(
          existingPermit?.orderLineIdWithVersion ?? existingPermit?.id
        );
      useAppConfigStore.getState().setNavigateType('CityParkingPmcItem');
      return navigate('duplicate');
    }
    navigate('viewScreen');
  };

  return { onItemSelect };
};

export default useSelectCityPmc;
